import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { BookingLink } from './BookingLink';
import { ShareLink } from './ShareLink';
const EASE = [0.23, 1, 0.32, 1] as const;
type SnakInvitationProps = {
  finished: boolean;
  onExplore: () => void;
};

/**
 * Sits above the phone, outside the Snak. Invites the visitor in; once the last chapter
 * is reached it becomes the meeting invitation — never overlapping scientific content.
 */
export function SnakInvitation({
  finished,
  onExplore
}: SnakInvitationProps) {
  return <div className="flex min-h-[64px] w-full items-end justify-center px-6 pb-4 md:px-0" aria-live="polite" data-id="element-672" data-mp="2jaab8x7mnbaj">
      <AnimatePresence mode="wait" initial={false} data-id="element-673" data-mp="2ejk35c7tguc5">
        {finished ? <motion.div key="book" className="flex flex-col items-center gap-2 text-center" initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} data-id="element-674" data-mp="1qu97g95bpq4v">
            <p className="text-[14px] font-medium text-ink" data-id="element-675" data-mp="1mtx6i1mxunhk">Interested in exploring what Snakker could do for Kyowa Kirin?</p>
            <BookingLink label="Book a discovery meeting" size="sm" data-id="element-676" data-mp="1rkm0poq05yke" />
          </motion.div> : <motion.div key="explore" className="flex flex-col items-center text-center" initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} data-id="element-677" data-mp="1wix8ltwqlyzz">
            <button type="button" onClick={onExplore} className="group inline-flex items-center gap-2 text-[20px] font-semibold tracking-[-0.02em] text-ink transition-colors duration-150 hover:text-navy focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-navy" data-id="element-678" data-mp="18tclqzxgqhlf">
              Explore the Snak
              <ArrowRightIcon size={18} strokeWidth={2} className="text-teal transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-679" data-mp="1zjgyh7mota3r" />
            </button>
            <p className="mt-1 text-[12.5px] text-graphite" data-id="element-680" data-mp="29iy2zlq7dhy5">An interactive scientific experience · approximately 80 seconds.</p>
            <ShareLink data-id="element-681" data-mp="24k4kfew270r4" />
          </motion.div>}
      </AnimatePresence>
    </div>;
}